import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-390" data-mp="33rmveynkjitg">
      <SEO title="Cookie Policy | KittyPot" description="How KittyPot, a shared expense and settlement tracker, uses cookies and similar technologies on our website." ogTitle="KittyPot Cookie Policy" ogDescription="How KittyPot uses cookies on our website." path="/cookie-policy" data-id="element-391" data-mp="2ytld4fxyvnj1" />
      <Navbar data-id="element-392" data-mp="3mg1jbd2lagq1" />
      <main className="pt-32 pb-24" data-id="element-393" data-mp="3mins1g17v29u">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-394" data-mp="3hhgipcjfdv12">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-395" data-mp="3hk2szjxpaomz">
            Cookie Policy
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-396" data-mp="3rfw89b2t0w8g">
            <p className="font-medium" data-id="element-397" data-mp="3re32rz3xgi21">Last updated: 14 December 2025</p>

            <p data-id="element-398" data-mp="1xx8if1y6ryid">
              This Cookie Policy explains how KittyPot Ltd ("Company," "we,"
              "us," and "our") uses cookies and similar technologies to
              recognize you when you visit our website at
              https://www.kittypot.com ("Website"). It outlines what cookies
              are, why we use them, and your rights to control their usage.
            </p>

            <p data-id="element-399" data-mp="2gtqd9s8c0eiu">
              In some cases, we may use cookies to collect personal information,
              or information that becomes personal when combined with other
              data.
            </p>

            <p data-id="element-400" data-mp="2pnln3dkeet4t">
              Current MVP: KittyPot is for expense tracking and manual
              settlement only. KittyPot does not currently hold funds, process
              payments, issue cards, or provide regulated e-money services.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-401" data-mp="34jb0woffjzyg">
              1. WHAT ARE COOKIES?
            </h2>
            <p data-id="element-402" data-mp="2ewqd78s81oeu">
              Cookies are small data files placed on your computer or mobile
              device when you visit a website. These files are commonly used by
              website owners to make websites work or perform more efficiently
              and to provide reporting data.
            </p>
            <p data-id="element-403" data-mp="2jtqlzrggh59n">
              Cookies set by the website owner (in this case, KittyPot Ltd) are
              referred to as "first-party cookies." Cookies set by parties other
              than the website owner are known as "third-party cookies."
              Third-party cookies allow the provision of third-party services on
              the website (e.g., advertising, interactive content, and
              analytics). These third parties may recognize your computer when
              you visit our website as well as when you visit other websites.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-404" data-mp="188jrl6kwkrzj">
              2. WHY DO WE USE COOKIES?
            </h2>
            <p data-id="element-405" data-mp="3jwyfkmmgl2kk">
              We use both first- and third-party cookies for various reasons.
              Some cookies are essential for technical reasons to make our
              website operate ("essential" or "strictly necessary" cookies).
              Other cookies help us track and target the interests of our users
              to improve their experience.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-406" data-mp="312syryeyacrv">
              3. HOW CAN I CONTROL COOKIES?
            </h2>
            <p data-id="element-407" data-mp="2r66dx9mmjlpu">
              You have the right to decide whether to accept or reject cookies.
              You can manage your cookie preferences via the Cookie Consent
              Manager. Essential cookies cannot be rejected as they are strictly
              necessary for the functionality of the website.
            </p>
            <p data-id="element-408" data-mp="ue639qduxn6e">
              The Cookie Consent Manager is available through the notification
              banner and on our website. If you choose to reject cookies, you
              can still use our website, but some features may not be
              accessible. You can also configure your web browser to accept or
              reject cookies.
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-409" data-mp="2ch9t1ocvorzw">
              Performance and Functionality Cookies
            </h3>
            <p data-id="element-410" data-mp="27iympnlskzmf">
              These cookies enhance the performance and functionality of our
              website but are not essential.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-411" data-mp="1xsdgpf3sgsth">
              <li data-id="element-412" data-mp="1xswwoq9vp74v">
                <strong data-id="element-413" data-mp="1xqar2w6jt1pa">Name:</strong> TS#
              </li>
              <li data-id="element-414" data-mp="1trtgg2nx5934">
                <strong data-id="element-415" data-mp="1tsd31woiklnh">Purpose:</strong> Enhances website security.
              </li>
              <li data-id="element-416" data-mp="1oqdwyf1e3amu">
                <strong data-id="element-417" data-mp="1oqxevvr1hz0v">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-418" data-mp="1jtx8fjqa2u98">
                <strong data-id="element-419" data-mp="1jte1ey261q9z">Type:</strong> HTTP Cookie
              </li>
              <li data-id="element-420" data-mp="3vewdtmyybdo3">
                <strong data-id="element-421" data-mp="3vffvr3olq224">Expires:</strong> Session
              </li>
            </ul>
            <ul className="list-disc pl-5 space-y-2 mt-4" data-id="element-422" data-mp="48llcf80bl8d">
              <li data-id="element-423" data-mp="98rddwi6v9qz">
                <strong data-id="element-424" data-mp="987t4952g99s">Name:</strong> XSRF-TOKEN
              </li>
              <li data-id="element-425" data-mp="96wv6pyaxvql">
                <strong data-id="element-426" data-mp="da2vlgyqgsp5">Purpose:</strong> Prevents Cross-Site Request Forgery
                (CSRF).
              </li>
              <li data-id="element-427" data-mp="3cq9bvdc2n4eq">
                <strong data-id="element-428" data-mp="3cqri92sg6z0d">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-429" data-mp="3hnrnxcldxzqy">
                <strong data-id="element-430" data-mp="3hpchozzvlenr">Type:</strong> HTTP Cookie
              </li>
              <li data-id="element-431" data-mp="3lpmkk3sdfoye">
                <strong data-id="element-432" data-mp="3lp3crfwfqgy3">Expires:</strong> Session
              </li>
            </ul>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-433" data-mp="3qh4lwsyb3rjw">
              Analytics and Customisation Cookies
            </h3>
            <p data-id="element-434" data-mp="2tyq8h5e4xoc6">
              These cookies help us understand how our website is used and
              improve user experience.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-435" data-mp="55jyqm6z7axx">
              <li data-id="element-436" data-mp="548xou4x0hai">
                <strong data-id="element-437" data-mp="53qrb4ojgmov">Name:</strong> bolt-performance
              </li>
              <li data-id="element-438" data-mp="6qjao84p9v4">
                <strong data-id="element-439" data-mp="560fvv6ffd3">Purpose:</strong> Tracks performance metrics
              </li>
              <li data-id="element-440" data-mp="ev3lw41q1qyl">
                <strong data-id="element-441" data-mp="9wtmfh8ys476">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-442" data-mp="9xlg2mj03rut">
                <strong data-id="element-443" data-mp="9z64dueq2ek8">Type:</strong> Pixel Tracker
              </li>
              <li data-id="element-444" data-mp="3icvgzrb5mr10">
                <strong data-id="element-445" data-mp="3iegcbj5amdzx">Expires:</strong> Session
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-446" data-mp="3dfd4jqxxhto9">
              4. HOW CAN I CONTROL COOKIES ON MY BROWSER?
            </h2>
            <p data-id="element-447" data-mp="3nb6qg0xjezip">
              You can manage cookies through your browser settings. Please refer
              to your browser's help section for guidance.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-448" data-mp="12lhd5schfls4">
              <li data-id="element-449" data-mp="12kph6gez3m1b">Chrome</li>
              <li data-id="element-450" data-mp="12nk023ic8ysm">Firefox</li>
              <li data-id="element-451" data-mp="1a59se3xd6ieu">Safari</li>
              <li data-id="element-452" data-mp="1a3yo8300b8n7">Edge</li>
              <li data-id="element-453" data-mp="1a3ozsjum19jm">Opera</li>
            </ul>
            <p className="mt-4" data-id="element-454" data-mp="1f4mf8oo8jphf">
              You can also opt out of targeted advertising via:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-455" data-mp="107lzljjbjkzb">
              <li data-id="element-456" data-mp="1096sz5twcxvl">Digital Advertising Alliance</li>
              <li data-id="element-457" data-mp="156ykhyqmqhz9">European Interactive Digital Advertising Alliance</li>
              <li data-id="element-458" data-mp="1svrkq7eabbzo">Digital Advertising Alliance of Canada</li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-459" data-mp="1sxu8slvvmv1r">
              5. OTHER TRACKING TECHNOLOGIES
            </h2>
            <p data-id="element-460" data-mp="1j6gecsis8lfh">
              We may use web beacons (tracking pixels) to measure website
              traffic and campaign effectiveness. These rely on cookies to
              function.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-461" data-mp="2bu3wm0wkyzyy">
              6. FLASH COOKIES
            </h2>
            <p data-id="element-462" data-mp="2gmn7gq3vvh02">
              We may use Flash cookies for fraud prevention and service
              functionality. You can manage Flash cookies via Adobe Flash Player
              settings.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-463" data-mp="bqt8u118vwul">
              7. TARGETED ADVERTISING
            </h2>
            <p data-id="element-464" data-mp="2rejx60q7uc7">
              Third-party advertisers may place cookies to deliver
              interest-based advertising. They do not collect personal data
              unless you provide it.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-465" data-mp="vgd4e9sbn8ko">
              8. POLICY UPDATES
            </h2>
            <p data-id="element-466" data-mp="qfxrtkfv653r">
              We may update this Cookie Policy periodically for legal,
              regulatory, or operational reasons.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-467" data-mp="lka3t8d4bhzu">
              9. Unicorn Platform Cookies
            </h2>
            <p data-id="element-468" data-mp="367vbmukmloo1">
              Our website is built using Unicorn Platform, which uses essential
              cookies required for core functionality.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-469" data-mp="313ar7c1s2qo6">
              10. CONTACT US
            </h2>
            <p data-id="element-470" data-mp="361ud5cgdg2gj">
              If you have any questions about this Cookie Policy, please contact
              us at support@kittypot.com or by post:
            </p>
            <address className="not-italic mt-4" data-id="element-471" data-mp="3auxbdxw3g032">
              KittyPot Ltd
              <br data-id="element-472" data-mp="3eufuqp89o33s" />
              Flat 2 Minavon
              <br data-id="element-473" data-mp="3jt99sm37c262" />
              Cardiff
              <br data-id="element-474" data-mp="3js7nflgqjt91" />
              South Glamorgan
              <br data-id="element-475" data-mp="3ot53nsi6qd7w" />
              CF14 6BE
              <br data-id="element-476" data-mp="3ou6nald9o818" />
              United Kingdom
            </address>
          </div>
        </div>
      </main>
      <Footer data-id="element-477" data-mp="3tr6x97d8luxm" />
    </div>;
}